import type { AdminDashboardData } from '@workspace/api-backend'
import { TimeSeriesChart } from '@workspace/ui/components/time-series-chart'
import { DashboardCard, DashboardSection } from './dashboard-card'

export function GrowthSection({ data }: { data: AdminDashboardData }) {
  return (
    <DashboardSection title="Growth">
      <div className="grid gap-4 lg:grid-cols-2">
        <DashboardCard
          title="Signups per day"
          subtitle="New users by role selected during onboarding"
        >
          <TimeSeriesChart
            data={data.signupsByDay}
            stacked
            series={[
              { key: 'founders', label: 'Founders', color: 'var(--chart-1)' },
              { key: 'investors', label: 'Investors', color: 'var(--chart-2)' },
              { key: 'noRole', label: 'No role yet', color: 'var(--chart-3)' },
            ]}
          />
        </DashboardCard>
        <DashboardCard title="Startups per day" subtitle="New startups created">
          <TimeSeriesChart
            data={data.startupsByDay}
            series={[{ key: 'created', label: 'Created', color: 'var(--chart-1)' }]}
          />
        </DashboardCard>
      </div>
    </DashboardSection>
  )
}
